import webuiState from "../app/InternalStateService";
import { extractEntityData, extractStorePath } from "../utils/storeUtils";

//action
//extracts selected item's id inside SelectableList
//changes geoMap (linked in dependencies) selectedMarker property
export function setMapFocusFromLocationListSirenAction(action, widgetId, path) {
    return (dispatch, getState) => {
        let entityData = extractEntityData(path, getState());
        let locationId = entityData.getIn(["properties", "selection"]);
        let dependencies = action.dependencies || [];
        let mapLink = dependencies[0];

        return dispatch(setGeolocationMapFocus(mapLink, locationId));
    };
}

//sets geoMap selectedMarker property
function setGeolocationMapFocus(mapLink, locationId) {
    return (dispatch, getState) => {
        let mapDataPath = extractStorePath(mapLink, getState());
        return dispatch(
            webuiState.getActionByName("component.triggerSet")([...mapDataPath, "properties"], {
                specificLocation: locationId
            })
        );
    };
}

export function setListSelectionFromGeoLocationMapSirenAction(action, widgetId, path) {
    return (dispatch, getState) => {
        let mapData = extractEntityData(path, getState());
        let selectedItemId = mapData.getIn(["properties", "specificLocation"]);
        let dependencies = action.dependencies || [];
        let listLink = dependencies[0];

        dispatch(setListSelection(listLink, selectedItemId));
        dispatch(webuiState.getActionByName("scroll.scrollTo")([listLink, selectedItemId]));
    };
}

function setListSelection(listLink, selectedItemId) {
    return (dispatch, getState) => {
        let listDataPath = extractStorePath(listLink, getState());
        return dispatch(
            webuiState.getActionByName("component.triggerSet")([...listDataPath, "properties"], {
                selection: selectedItemId
            })
        );
    };
}
